import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import StandardLayout from '@@layouts/StandardLayout'
import SEO from '@@components/seo'
import { PublishDate, ArticleHeadline, ArticleAuthor } from '@@components/common'
import { useGetAllBio } from '@@root/hooks'

import styles from './ArticlePage.module.scss'

export const ArticlePage = ({ pageContext: article }) => {
  const { name } = useGetAllBio()

  return (
    <StandardLayout>
      <SEO title={article.title} />
      <article className={styles.articlePage}>
        <header className={styles.header}>
          <ArticleHeadline headline={article.title} />
          <PublishDate date={article.date} className={styles.publishDate} />
        </header>
        <section className={styles.body}>
          <ReactMarkdown source={article.body} />
        </section>
        <ArticleAuthor name={name} className={styles.articleAuthor} />
      </article>
    </StandardLayout>
  )
}
ArticlePage.propTypes = {
  pageContext: PropTypes.any,
}
